import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import App from "./App";
import router from "./router";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import ssWatcher from "vue-storage-watcher";
import VueGtag from "vue-gtag";
require("@/assets/css/style-resultados.css");

Vue.use(BootstrapVue);
Vue.use(ssWatcher, { prefix: "admis_", storage: "session" });
Vue.config.productionTip = false;

Vue.use(
  VueGtag,
  {
    config: {
      id: GTAG_ANALYTICS_KEY
    }
  },
  router
);

new Vue({
  el: "#app",
  router,
  template: "<App/>",
  components: { App }
});



// WEBPACK FOOTER //
// ./src/main.js